const regionTab = document.getElementById("regionbtn"); 
const regionInfo = document.getElementById("regionInfo"); 
const openRegionInfo = document.getElementById("openRegionInfo"); 
const closeRegionInfo = document.getElementById("closeRegionInfo"); 

const metropolitanaTab = document.getElementById("metropolitanabtn"); 
const metropolitanaInfo = document.getElementById("metropolitana_info");
const openMetropolitanaInfo = document.getElementById("openMetropolitanaInfo"); 
const closeMetropolitanaInfo = document.getElementById("closeMetropolitanaInfo"); 

regionTab.addEventListener('click', () => {
  regionInfo.classList.toggle("toggleTab")
  openRegionInfo.classList.toggle("toggleTab")
  closeRegionInfo.classList.toggle("toggleTab")
})
metropolitanaTab.addEventListener('click', () => {
  metropolitanaInfo.classList.toggle("toggleTab")
  openMetropolitanaInfo.classList.toggle("toggleTab")
  closeMetropolitanaInfo.classList.toggle("toggleTab")
})
const changeRegionMetropolitana = document.getElementById("regionMetropolitanaTimetrack")
const regionMetropolitanaResult = document.getElementById("region_metropolitana_result")
const changeRegion = document.getElementById("regionTimetrack")
const regionResult = document.getElementById("region_result")

changeRegionMetropolitana.addEventListener("change", () => {
  regionMetropolitanaResult.innerHTML = ""
  regionMetropolitanaResult.innerHTML = changeRegionMetropolitana.value
})

changeRegion.addEventListener("change", () => {
  regionResult.innerHTML = ""
  regionResult.innerHTML = changeRegion.value
})